import React from 'react';

import './Footer.scss';

export const Footer = () =>
{
    return(
        <footer id="Footer">
            <i>
                &copy; 2021 (Bald 2022) CrazyCoders!
            </i>
        </footer>
    )
}
